import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C01AccordionProps } from './C01Accordion.types';
import { ACCORDION_ITEM_CONTAINER } from 'src/shared/static';
import { AccordionWrapperProps, SvgIconType } from '@ahc-digital/component-library';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { getKvpValue } from '@/shared/field-utils';

export function CreateAccordionWrapperModel(props?: C01AccordionProps) {
  type t = AccordionWrapperProps;

  const { rendering, params, fields } = props || {};
  const { renderText, renderRichText } = useConditionalRendering();

  const defaultOpenItem =
    rendering?.placeholders?.[ACCORDION_ITEM_CONTAINER]?.find(({ uid }) => !!uid)?.uid || '';

  // headlineAlignment & headlineIconPlacement are droplists, NOT droplinks.
  // We did not want to change the field type and possibly break functionality
  return {
    accordionItems: rendering ? (
      <Placeholder name={ACCORDION_ITEM_CONTAINER} rendering={rendering} />
    ) : (
      <></>
    ),
    defaultOpenItem: defaultOpenItem,
    headline: renderText(fields?.Headline) as t['headline'],
    headlineAlignment: (params?.HeadlineAlignment || 'center') as t['headlineAlignment'],
    headlineIcon: getKvpValue(fields?.HeadlineIcon) as SvgIconType,
    headlineIconPlacement: (params?.HeadlineIconPlacement || 'left') as t['headlineIconPlacement'],
    headlineTag: getKvpValue(fields?.HeadlineTag, 'p'),
    shouldOpenFirstItem: !!params?.OpenFirstItem,
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    type: (params?.LimitToSingleItem ? 'single' : 'multiple') as t['type'],
  };
}
